import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { setTitleCase } from "app/components/template/partials";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteUser } from "utils/action";

export function DeleteUser() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const [isLoading, setLoading] = useState(false);
  const showDialog = location.state?.showDialog ?? false;
  const userData = location.state?.userData ?? null;
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleFormSubmit = async (values) => {
    setLoading(true);

    // send to backend
    try {
      await deleteUser(values.username);
      toast.success(setTitleCase("berhasil menghapus data pengguna"));
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
    onHide();
  };

  const onHide = () => {
    navigate(-1);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      open={showDialog}
      onClose={onHide}
      aria-labelledby="responsive-dialog-delete-user-title"
      className="dialog-container"
    >
      <DialogTitle id="responsive-dialog-delete-user-title">
        Hapus Pengguna
      </DialogTitle>
      <Divider />

      <DialogContent className="dialog-content-column">
        <img
          src="/assets/images/alert.webp"
          width="30%"
          height="30%"
          alt="delete-user images"
          loading="lazy"
        />
        <div className="dialog-content-spacing">
          <Grid container spacing={2} className="dialog-content-text">
            <Grid item md={12} xs={12}>
              <Typography className="dialog-content-key-text">
                NAMA PENGGUNA
              </Typography>
              <Typography gutterBottom className="dialog-content-value-text">
                {userData?.username}
              </Typography>
              <Divider />
            </Grid>
            <Grid item md={12} xs={12}>
              <Typography className="dialog-content-key-text">
                NO.TELEPON
              </Typography>
              <Typography gutterBottom className="dialog-content-value-text">
                {userData?.email_nohp}
              </Typography>
              <Divider />
            </Grid>
          </Grid>
        </div>
        <div className="dialog-content-spacing">
          <Typography className="dialog-confirm-text">
            Apakah anda yakin untuk menghapus data pengguna ini ?
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onHide} color="error" variant="contained">
          Batal
        </Button>
        <LoadingButton
          autoFocus
          loading={isLoading}
          color="primary"
          variant="contained"
          onClick={() => handleFormSubmit(userData)}
        >
          Hapus
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
